import {
  FETCH_TEAM_MEMBERS,
  FETCH_TEAM_MEMBERS_SUCCESS,
  FETCH_TEAM_MEMBERS_FAILURE,
  DELETE_TEAM_MEMBER,
  DELETE_TEAM_MEMBER_SUCCESS,
  DELETE_TEAM_MEMBER_FAILURE,
  ADD_TEAM_MEMBER,
  ADD_TEAM_MEMBER_SUCCESS,
  ADD_TEAM_MEMBER_FAILURE,
  UPDATE_TEAM_MEMBER,
  UPDATE_TEAM_MEMBER_SUCCESS,
  UPDATE_TEAM_MEMBER_FAILURE,
  FETCH_PROJECT_ROLES,
  FETCH_PROJECT_ROLES_SUCCESS,
  FETCH_PROJECT_ROLES_FAILURE,
  FETCH_CERTIFICATIONS,
  FETCH_CERTIFICATIONS_SUCCESS,
  FETCH_CERTIFICATIONS_FAILURE,
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  GET_PRESIGNED_URL,
  GET_PRESIGNED_URL_SUCCESS,
  GET_PRESIGNED_URL_FAILURE,
  UPLOAD_CERTIFICATE,
  UPLOAD_CERTIFICATE_SUCCESS,
  UPLOAD_CERTIFICATE_FAILURE,
  CREATE_UPDATE_TEAM_MEMBER,
  CREATE_UPDATE_TEAM_MEMBER_SUCCESS,
  CREATE_UPDATE_TEAM_MEMBER_FAILURE,
  DELETE_TEAM_MEMBER_CERT,
  DELETE_TEAM_MEMBER_CERT_SUCCESS,
  DELETE_TEAM_MEMBER_CERT_FAILURE,
  CREATE_UPDATE_PROJECT_LEVEL_ROLES,
  CREATE_UPDATE_PROJECT_LEVEL_ROLES_SUCCESS,
  CREATE_UPDATE_PROJECT_LEVEL_ROLES_FAILURE,
  DELETE_PROJECT_LEVEL_ROLE,
  DELETE_PROJECT_LEVEL_ROLE_SUCCESS,
  DELETE_PROJECT_LEVEL_ROLE_FAILURE
} from './types';

const initialState = {
  teamMembers: [],
  loading: false,
  error: null,
  deleteLoading: false,
  addLoading: false,
  updateLoading: false,
  projectRoles: [],
  certifications: [],
  rolesLoading: false,
  certificationsLoading: false,
  users: [],
  usersLoading: false,
  presignedUrl: null,
  presignedUrlLoading: false,
  uploadLoading: false,
  createUpdateLoading: false,
  isRefreshingData: false,
  deleteCertLoading: false,
  createUpdateRolesLoading: false,
  deleteRoleLoading: false
};

const teamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEAM_MEMBERS:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        teamMembers: action.payload?.data || [],
        error: null,
        // If we were refreshing data after create/update, mark it as complete
        isRefreshingData: false
      };

    case FETCH_TEAM_MEMBERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          type: 'FETCH_ERROR',
          message: action.error || 'Failed to fetch team members',
          timestamp: Date.now()
        }
      };

    case DELETE_TEAM_MEMBER:
      return {
        ...state,
        deleteLoading: true,
        error: null,
        // Optimistically remove the team member for immediate UI feedback
        teamMembers: Array.isArray(state.teamMembers)
          ? state.teamMembers.filter((member) => {
              const idToRemove = action?.payload?.teamMemberId?.toString?.();
              if (!idToRemove) return true;
              const memberId = member?.id?.toString?.();
              const memberNumericId = member?.team_member_id?.toString?.();
              return memberId !== idToRemove && memberNumericId !== idToRemove;
            })
          : state.teamMembers
      };

    case DELETE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        error: null
      };

    case DELETE_TEAM_MEMBER_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.error || 'Failed to delete team member'
      };

    case ADD_TEAM_MEMBER:
      return {
        ...state,
        addLoading: true,
        error: null
      };

    case ADD_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        addLoading: false,
        error: null
      };

    case ADD_TEAM_MEMBER_FAILURE:
      return {
        ...state,
        addLoading: false,
        error: action.error || 'Failed to add team member'
      };

    case UPDATE_TEAM_MEMBER:
      return {
        ...state,
        updateLoading: true,
        error: null
      };

    case UPDATE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        error: null
      };

    case UPDATE_TEAM_MEMBER_FAILURE:
      return {
        ...state,
        updateLoading: false,
        error: action.error || 'Failed to update team member'
      };

    case FETCH_PROJECT_ROLES:
      return {
        ...state,
        rolesLoading: true,
        error: null
      };

    case FETCH_PROJECT_ROLES_SUCCESS:
      return {
        ...state,
        rolesLoading: false,
        projectRoles: action.payload?.data || [],
        error: null
      };

    case FETCH_PROJECT_ROLES_FAILURE:
      return {
        ...state,
        rolesLoading: false,
        error: action.error || 'Failed to fetch project roles'
      };

    case FETCH_CERTIFICATIONS:
      return {
        ...state,
        certificationsLoading: true,
        error: null
      };

    case FETCH_CERTIFICATIONS_SUCCESS:
      return {
        ...state,
        certificationsLoading: false,
        certifications: action.payload?.data || [],
        error: null
      };

    case FETCH_CERTIFICATIONS_FAILURE:
      return {
        ...state,
        certificationsLoading: false,
        error: action.error || 'Failed to fetch certifications'
      };

    case FETCH_USERS:
      return {
        ...state,
        usersLoading: true,
        error: null
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        usersLoading: false,
        users: action.payload?.data || [],
        error: null
      };

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        usersLoading: false,
        error: action.error || 'Failed to fetch users'
      };

    case GET_PRESIGNED_URL:
      return {
        ...state,
        presignedUrlLoading: true,
        error: null
      };

    case GET_PRESIGNED_URL_SUCCESS:
      return {
        ...state,
        presignedUrlLoading: false,
        presignedUrl: action.payload?.data || null,
        error: null
      };

    case GET_PRESIGNED_URL_FAILURE:
      return {
        ...state,
        presignedUrlLoading: false,
        error: action.error || 'Failed to get presigned URL'
      };

    case UPLOAD_CERTIFICATE:
      return {
        ...state,
        uploadLoading: true,
        error: null
      };

    case UPLOAD_CERTIFICATE_SUCCESS:
      return {
        ...state,
        uploadLoading: false,
        error: null
      };

    case UPLOAD_CERTIFICATE_FAILURE:
      return {
        ...state,
        uploadLoading: false,
        error: action.error || 'Failed to upload certificate'
      };

    case CREATE_UPDATE_TEAM_MEMBER:
      return {
        ...state,
        createUpdateLoading: true,
        error: null
      };

    case CREATE_UPDATE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        createUpdateLoading: false,
        isRefreshingData: true,
        error: null
      };

    case CREATE_UPDATE_TEAM_MEMBER_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        isRefreshingData: false,
        // Store the error with context to distinguish it from fetch errors
        error: {
          type: 'CREATE_UPDATE_ERROR',
          message: action.error || 'Failed to create/update team member',
          timestamp: Date.now()
        }
      };

    case DELETE_TEAM_MEMBER_CERT:
      return {
        ...state,
        deleteCertLoading: true,
        error: null
      };

    case DELETE_TEAM_MEMBER_CERT_SUCCESS:
      return {
        ...state,
        deleteCertLoading: false,
        error: null
      };

    case DELETE_TEAM_MEMBER_CERT_FAILURE:
      return {
        ...state,
        deleteCertLoading: false,
        error: action.error || 'Failed to delete certificate'
      };

    case CREATE_UPDATE_PROJECT_LEVEL_ROLES:
      return {
        ...state,
        createUpdateRolesLoading: true,
        error: null
      };

    case CREATE_UPDATE_PROJECT_LEVEL_ROLES_SUCCESS:
      return {
        ...state,
        createUpdateRolesLoading: false,
        error: null
      };

    case CREATE_UPDATE_PROJECT_LEVEL_ROLES_FAILURE:
      return {
        ...state,
        createUpdateRolesLoading: false,
        error: action.error || 'Failed to create/update project level roles'
      };

    case DELETE_PROJECT_LEVEL_ROLE:
      return {
        ...state,
        deleteRoleLoading: true,
        error: null
      };

    case DELETE_PROJECT_LEVEL_ROLE_SUCCESS:
      return {
        ...state,
        deleteRoleLoading: false,
        error: null
      };

    case DELETE_PROJECT_LEVEL_ROLE_FAILURE:
      return {
        ...state,
        deleteRoleLoading: false,
        error: action.error || 'Failed to delete project level role'
      };

    case 'CLEAR_TEAM_MEMBERS_ERROR':
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default teamMembersReducer; 